import { css } from "@emotion/react";
import { vars } from "@imwebme/clay-token";
import type { ContentsBannerProps } from ".";

export const containerCSS = ({
  title,
  variant,
  type,
}: Pick<ContentsBannerProps, "type" | "variant" | "title">) =>
  css({
    display: "flex",
    gap: vars.spacing[2],
    alignItems: title ? "flex-start" : "center",
    ...(variant === "default" && type !== "primary" && { backgroundColor: "transparent" }),
    ...(variant !== "default" && type !== "primary" && { border: "none", outline: "none" }),
  });

const _default = css({
  backgroundColor: vars.semantic.color.surfaceSub,
  outlineColor: vars.semantic.color.border,
  borderColor: vars.semantic.color.border,
  "button, a": {
    backgroundColor: "transparent",
    color: vars.semantic.color.textAccent,

    "&:hover": {
      color: vars.semantic.color.textAccentHover,
    },
  },
});

const critical = css({
  backgroundColor: vars.semantic.color.surfaceCriticalSecondary,
  outlineColor: vars.semantic.color.borderCritical,
  borderColor: vars.semantic.color.borderCritical,
  "button, a": {
    backgroundColor: "transparent",
    color: vars.semantic.color.textCritical,

    "&:hover": {
      color: vars.semantic.color.textCriticalHover,
    },
  },
});

const warning = css({
  backgroundColor: vars.semantic.color.surfaceWarningSecondary,
  outlineColor: vars.semantic.color.borderWarning,
  borderColor: vars.semantic.color.borderWarning,
  "button, a": {
    backgroundColor: "transparent",
    color: vars.semantic.color.textWarning,

    "&:hover": {
      color: vars.semantic.color.textWarningHover,
    },
  },
});

const information = css({
  backgroundColor: vars.semantic.color.surfaceHighlightSecondary,
  outlineColor: vars.semantic.color.borderHighlight,
  borderColor: vars.semantic.color.borderHighlight,
  "button, a": {
    backgroundColor: "transparent",
    color: vars.semantic.color.textAccent,

    "&:hover": {
      color: vars.semantic.color.textAccentHover,
    },
  },
});

const success = css({
  backgroundColor: vars.semantic.color.surfaceSuccessSecondary,
  outlineColor: vars.semantic.color.borderSuccess,
  borderColor: vars.semantic.color.borderSuccess,
  "button, a": {
    backgroundColor: "transparent",
    color: vars.semantic.color.textSuccess,
  },
});

export const variantStyle = {
  default: _default,
  critical,
  warning,
  information,
  success,
};

const primary = css({
  padding: vars.spacing[4],

  borderLeftWidth: "4px",
  borderLeftStyle: "solid",
});

const secondary = css({
  padding: `${vars.spacing[3]} ${vars.spacing[4]}`,

  outlineWidth: "1px",
  outlineStyle: "solid",
  outlineOffset: "-1px",
  borderRadius: vars.rounded.medium,
});

export const typeStyle = {
  primary,
  secondary,
  minimal: secondary,
};
